var _defs, _path, _path2, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwinspires(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Tweakad",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 144.46 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 0,
    y: 13.38,
    width: 9.66,
    height: 21.51,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0,13.38v21.5H9.66V13.38Z",
    fill: "#fff",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    x: 0,
    y: 0,
    width: 144.49,
    height: 40.01,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M0,40H144.49V0H0Z",
    fill: "#fff",
    fillRule: "evenodd"
  }))))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Logos") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30,18.63h4L29.18,34.75H25.35l-2.9-10.28L19.34,34.75H15.55L10.89,18.63h4l2.8,11,3-11h3.44l2.95,11",
    fill: "#ffffff",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.89,18.63H47.8v1.91A4.27,4.27,0,0,1,49,19.27a6.7,6.7,0,0,1,3.71-1.12A5.24,5.24,0,0,1,57,20.08c1,1.35,1,3.09,1,5.19v9.48H54.13V26.53A11.31,11.31,0,0,0,54,24.08a2.61,2.61,0,0,0-2.63-2.15,3.37,3.37,0,0,0-3,1.79,9.46,9.46,0,0,0-.6,4v7h-3.9V18.63Z",
    fill: "#fff",
    fillRule: "evenodd"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.66,21.41l-.81-2.78H6.21V13.38H2.35v5.25H0v2.78H2.35v8.21a10.82,10.82,0,0,0,.25,3.29c.75,2,3.45,2,4.26,2a15.3,15.3,0,0,0,2.8-.26V31.38a5.42,5.42,0,0,1-1.61.19c-1.84,0-1.84-.87-1.84-2.87V21.41Z",
    fill: "#ffffff",
    fillRule: "evenodd"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.26,34.75h3.83V18.63H36.26m5.29-3a4.88,4.88,0,0,1-1.49-2.36l-1-5.16L38.83,6.8h.1a.25.25,0,0,0,.25-.25.25.25,0,0,0-.25-.25h-.19l-.13-.69.19-.67a.2.2,0,0,0,.2-.19.2.2,0,0,0-.21-.19.19.19,0,0,0-.16.08,2,2,0,0,0-.15.32l0,0V.32a.34.34,0,0,0-.3-.31.3.3,0,0,0-.3.31V4.94a.08.08,0,0,0,0,0v0s-.1-.23-.15-.31a.24.24,0,0,0-.16-.08.2.2,0,1,0,0,.4l.19.66-.14.7h-.19a.24.24,0,0,0-.25.25.25.25,0,0,0,.25.25h.09l-.22,1.35-1,5.16a4.82,4.82,0,0,1-1.49,2.35.26.26,0,0,0,.16.46h6.43a.25.25,0,0,0,.24-.17.31.31,0,0,0,0-.09.23.23,0,0,0-.1-.2M62.85,30A5.63,5.63,0,0,0,67.48,32c2.23,0,3.2-1.09,3.2-1.89,0-1-1.17-1.29-1.69-1.4s-3.18-.61-3.75-.77c-3.83-.92-4.55-3.13-4.55-4.58,0-2.75,2.48-5.25,6.88-5.25a9.17,9.17,0,0,1,5.32,1.53,7,7,0,0,1,1.63,1.46l-2.73,2.55a4.48,4.48,0,0,0-4.37-2.46c-1.83,0-2.67.81-2.67,1.64,0,1.16,1.19,1.5,3.25,1.84,3.35.61,4.28.77,5.31,1.58A4.39,4.39,0,0,1,75,29.69c0,2.52-2.26,5.51-7.24,5.51A11,11,0,0,1,60,32.35L62.87,30Zm22.08,1.6c1.87,0,3.9-1.29,3.9-4.93,0-4-2.8-4.81-4-4.81-1.77,0-3.79,1.29-3.87,4.74s1.77,5,3.93,5ZM77.22,18.63h3.83v1.48a5.68,5.68,0,0,1,4.41-2c4.72,0,7.32,4.25,7.32,8.69,0,4.81-3,8.39-7.32,8.39a6.29,6.29,0,0,1-4.41-1.81V40H77.22V18.62Zm46.88,6c-.36-2.52-1.91-3.39-3.61-3.39a3.82,3.82,0,0,0-3.93,3.39Zm4.37,6.51a9.31,9.31,0,0,1-7.86,4.09c-4.2,0-8.27-2.68-8.27-8.61,0-5.41,3.46-8.47,8-8.47a7.32,7.32,0,0,1,6.35,3c1.32,1.88,1.6,4.69,1.63,6.29H116.42c.46,2.55,2,4,4.58,4a4.77,4.77,0,0,0,4.2-2.24l3.26,1.9ZM132.36,30A5.61,5.61,0,0,0,137,32c2.21,0,3.19-1.09,3.19-1.89,0-1-1.17-1.29-1.69-1.39s-3.17-.61-3.75-.77c-3.83-.9-4.54-3.13-4.54-4.58,0-2.73,2.48-5.25,6.89-5.25a9.34,9.34,0,0,1,5.31,1.53A8.16,8.16,0,0,1,144,21.14L141.3,23.7a4.49,4.49,0,0,0-4.38-2.46c-1.83,0-2.67.81-2.67,1.64,0,1.16,1.19,1.5,3.25,1.84,3.35.61,4.29.77,5.32,1.58a4.37,4.37,0,0,1,1.64,3.41c0,2.52-2.25,5.51-7.23,5.51a11.07,11.07,0,0,1-7.74-2.86L132.36,30ZM106.62,18.62V20.9c.48-.83,1.55-2.73,5.14-2.64v4a5.83,5.83,0,0,0-3.46,1c-1.65,1.26-1.69,2.9-1.69,5.58v6H102.9V18.62ZM95.39,34.74h3.83V18.62H95.39m5.3-3a4.81,4.81,0,0,1-1.49-2.35l-1-5.16L98,6.79h.1a.26.26,0,0,0,.26-.25.26.26,0,0,0-.25-.25h-.19l-.14-.69.19-.67a.2.2,0,0,0,.19-.19.2.2,0,0,0-.2-.2.22.22,0,0,0-.16.07,2,2,0,0,0-.15.32v0l0-4.59a.34.34,0,0,0-.3-.3A.31.31,0,0,0,97,.3V4.93a2.29,2.29,0,0,0-.16-.32.22.22,0,0,0-.16-.07.2.2,0,0,0-.19.19.2.2,0,0,0,.19.2l.2.67c-.05.21-.09.45-.14.69h-.19a.26.26,0,0,0,0,.51h.1l-.26,1.36-1,5.16A4.8,4.8,0,0,1,94,15.68a.29.29,0,0,0-.08.29.27.27,0,0,0,.24.17h6.44a.26.26,0,0,0,.24-.17.19.19,0,0,0,0-.08.24.24,0,0,0-.1-.19",
    fill: "#ffffff",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwinspires);
export default __webpack_public_path__ + "static/media/twinspires.92788677cafedd103724b157dd053e74.svg";
export { ForwardRef as ReactComponent };